import React, { useEffect, useState } from 'react';
import { Button } from 'antd-mobile';
import styles from './agree.module.scss';

function AgreeComponent(props: any) {

    const [type, setType] = useState<any>(null);
    const [agree, setAgree] = useState<any>(null);

    useEffect(() => {
        
        if (props.match.params) {
            let type = sessionStorage.getItem('currentType')
            setType(type)
            if (props.match.params.type) {
                setAgree(props.match.params.type)
            }
        }
        
    }, [])

    const goBack = (b: any) => {
        if (type == 'phonenumber') {
            props.history.push({ pathname: `/findList/phoneNumber/phoneNumber`, params: {checked: b} })
        } else {
            props.history.push({ pathname: `/findList/passWord/passWord`, params: {checked: b} })
        }
    }

    return (
        <div className={styles.agreeContent}>
            {
                agree == "privacy" ?
                    <div className={styles.contentWrap}>
                        <div className={styles.title}>用户隐私协议</div>
                        <div className={styles.content}>
                            尊敬的用户，我们非常重视您的个人信息和隐私保护，为了更好地保障您的个人权益，本协议将向您说明：<br />
                            1、我们可能会根据您的授权获取您在科研数据助手小程序中的个人信息，您有权拒绝；<br />
                            2、我们会采取行业领先的安全措施保护您的个人信息安全；<br />
                            3、未经您同意，我们不会从第三方处获取、共享或向其提供您的信息；<br />
                            本隐私政策适用于您通过任何方式使用科研数据小助手平台提供的全部产品和/或服务（本隐私政策中统称为惠每临床科研平台服务）的使用而提供或留存的信息，我们希望通过本隐私政策向您说明在您使用惠每临床科研平台服务时，我们是如何收集、使用、保存、共享和转让这些信息，以及我们将为您提供访问、更新、删除、保护以及注销这些信息的方式。
                            个人信息是指以电子或者其他方式记录的能够单独或者与其他信息，结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。如姓名、出生日期、身份证件号码、个人生物识别信息、住址、通信通讯联系方式、通信记录和内容、账号密码、财产信息、征信信息、行踪轨迹、住宿信息、健康生理信息、交易信息等。具体的关于个人信息的定义以及本隐私政策将涉及到的个人信息，将通过本隐私政策如下具体内容的阐述以及第十章节的定义和名词解释进行明确。
                            我们会根据本隐私政策的约定，为实现我们的产品和/或服务功能而对所收集的个人信息进行使用。<br />
                            在收集您的个人信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将不含可识别到具体个人身份的信息。请您了解并同意，在此情况下我们有权使用已经去标识化的信息；并在不透露您个人信息的前提下，我们有权对用户数据库进行分析并予以商业化的利用。
                            我们会对我们的产品与 / 或服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的产品与 / 或服务的整体使用趋势。但这些统计信息将进行匿名化处理，不包含您的任何身份识别信息。
                            在您选择公开您的问答内容而需展示您的个人信息时，我们会采用打码、替换、匿名处理方式对您的信息进行脱敏，使您不可被直接识别以保护您的信息安全。
                            我们将在以下情况或出于以下目的，收集和使用您的个人信息：<br /><br />

                            （一）注册、登录
                            <br />
                            1、您账号注册成功后，您可以补充您的头像、手机号、性别、所在医院、科室、职称以及您实名验证的相关信息，这些信息均属于您的”账号信息”，同时如果您提供该等信息，将有助于更好地帮助我们提供更好的服务和体验。但如果您不提供这些补充和额外信息，将不会影响使用本服务的基本功能。
                            <br />
                            2、实名认证：您可以根据认证要求提供相应的身份信息（身份证、护照、户口簿及其他身份证件信息）以完成实名认证。若您需使用账户增强保护功能。
                            <br />
                            4、授权登录：我们可能经您同意后向第三方共享您的账户信息（头像、手机号、性别、所在医院、科室、职称以及您实名验证的相关信息），使您可以便捷地实现第三方账户的注册或第三方处直接登录。此外，我们可能会根据您的授权从微信、支付宝等第三方处获取您的第三方账户信息，并与您的科研数据助手平台账户进行绑定，使您可在第三方处直接登录、使用我们的产品及/或服务。我们将在您授权同意的范围内使用您的相关信息。
                            <br />
                            6 、如您不注册账号，可通过微信登录这种第三方平台授权登录，我们仍然需要绑定您的电话号码，通过电话号码来验证您的身份是否有效。
                            <br />
                            7 、如您拒绝提供手机号码、身份证号码进行实名验证以及医生信息的，将可能导致与第三方平台账号绑定不成功，绑定失败后您不可以通过科研数据助手平台进入第三方平台。<br /><br />
                        </div>
                    </div> :
                    <div className={styles.contentWrap}>
                        <div className={styles.title}>用户服务协议</div>
                        <div className={styles.content}>
                            所有即将进入『医生工作室』的用户，包括但不限于已注册医生工作室用户和未注册医生工作室用户，
                            在使用『医生工作室』提供的任何服务前，必须事先认真阅读并同意本用户协议。
                            <br /><br />
                            『医生工作室』是惠每移健（北京）客户有限公司推出的一款主要提供医疗指南咨询和诊疗工具服务的产品，
                            同时包含指南共识阅读和下载、轻量级CDCS工具、肿瘤治疗决策树和微问卷等等。
                            <br /><br />
                            如果您同意本用户协议，或者您事实上存在使用行为，将被视为您完全接受本用户协议的全部内容及条款，
                            包括接受『医生工作室』对用户协议随时所做的任何修改及更新，同时也表示您同意『医生工作室』所发布或随时更新的隐私声明，
                            本协议即构成对双方均具有约束力的法律文件。如您不同意本用户协议，您应不得使用或主动取消『医生工作室』所提供的服务。<br /><br />
                        </div>
                    </div>
            }
            
            <div className={styles.buttonGroup}>
                <Button
                    className={`${styles.btn} ${styles.cancel}`}
                    onClick={() => goBack(false)}
                >
                    暂不同意
                </Button>
                <Button
                    className={styles.btn}
                    onClick={() => goBack(true)}
                >
                    同意并确认
                </Button>
            </div>
        </div>
    )

}

export default AgreeComponent;